import { Modal, PDFRenderer } from "components";
import { useMatch, useSearch } from "react-location";

import { LocationGenerics } from "router/location";
import config from "config";
import { processUrlData } from "utils/url";

export default function ViewInsurerPaymentReceiptContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const { params } = useMatch<LocationGenerics>();

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      size="6xl"
      title="Payment Receipt"
      description="Details of payment receipt are shown below"
    >
      <PDFRenderer
        url={`${config.asset.uri}payment_receipt/${processUrlData({
          offer_id: params?.offer,
          payment_id: searchParams?.id,
        }
        )}`}
      />
    </Modal>
  );
}
